"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'konstellation',
    client_id: '07-tendermint-1',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1778',
    connection_id: 'connection-1384'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-171',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}];
var _default = exports["default"] = info;